export default __webpack_public_path__ + "static/media/user_female.ae545274.png";